import { createSelector } from 'reselect';

export const getCurrenciesList = state => state.currency?.currencyList;

export const makeCurrentCurrency = () => {
  return createSelector(
    getCurrenciesList,
    (state, props) => props.currency,
    (currencies, slug) => {
      if (slug) {
        return currencies.filter(item => item.name.toLowerCase() === slug)?.[0];
      }
      return null;
    }
  );
};
export const getCurrentCurrency = makeCurrentCurrency();
